module.exports = __webpack_public_path__ + "static/media/script-after@2x.706ff22c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CallTools/Redesign/script-after@2x.png
// module id = ./src/assets/CallTools/Redesign/script-after@2x.png
// module chunks = 0